// removed by extract-text-webpack-plugin
module.exports = {"component":"_3NRWSW23ChjCAhRTm1gUo4","componentInner":"hI3jgR84rlkLgTlRQX5Vo","header":"_7I32TNF3P0EuiJccxCxbA","primary":"_1YDM9-59q5fnQh0N-nAW7z","secondary":"_276tj9AlRbN4nMZEy4VckB","details":"_3OfPblug_M-QlD6ZR5uByw","actions":"_3X5nf39R6LP6wDfiCqp5OH","buttonRow":"_2WpCEAQDkeWaqWTxa0u8qG","buttonContainer":"_2LOZrT1K2bhtVIS6FvorAO","btn":"_3DJvT0MwPLt7SJ_bi1Zd0k","label":"_3b2gsgyuww030YJ5VekHIr","cancel":"_2t0P7SeWZG-BGEEAK19DIT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Appointments/DetailMobileView/DetailMobileViewContainer.css
// module id = 1403
// module chunks = 0